export const setTabTitle = (tabTitle) => {
    document.title = `Kaliber - ${tabTitle} `
}
